let registerFormPassword = document.getElementById('RegisterForm-password');
let passwordStrengthContainer = document.getElementById('password-strength-container')
registerFormPassword.addEventListener('keyup', function() {
  let passwordArray = registerFormPassword.value.split('');
  let duplicateCount = 0;
  let tripleCount = 0;
  passwordStrengthContainer.classList.remove('d-none')
  let totalScore = 0;

  const rating = {
    number: 0,
    lowercase: 0,
    uppercase: 0,
    specialChar: 0,
    consecutive: 0,
    total: 0
  }

  const validation = {
    isNumber: function (val) {
      const pattern = /^\d+$/;
      return pattern.test(val);
    },
    isLowercase: function (val) {
      const pattern = /[a-z]/;
      return pattern.test(val);
    },
    isUppercase: function (val) {
      const pattern = /[A-Z]/;
      return pattern.test(val);
    },
    isSpecialChar: function (val) {
      const pattern = /^[!@#\$%\^\&*\)\(+=._-]+$/g;
      return pattern.test(val);
    },
    checkConsecutiveCharacters: function (val){
      // Get the length of the string
      let l = val.length;
      let hasConsecutiveChars = false;
      // sort the given string
      val.sort();

      // Iterate for every index and
      // check for the condition
      for (let i = 1; i < l; i++) {
        // If are not consecutive
        if (
          (val[i + 1].charCodeAt(0) - val[i].charCodeAt(0)) === 1 &&
          (val[i + 2].charCodeAt(0) - val[i + 1].charCodeAt(0)) === 1
        )
          hasConsecutiveChars = true;
      }
      return hasConsecutiveChars
    }
  }

  function checkTwoCharRepetition(inputPassword) {
    for (var i = 0; i < inputPassword.length; i++){
      if (inputPassword[i] === inputPassword[i + 1]){
        duplicateCount = duplicateCount + 1;
      }
    }
  }
  function checkThreeCharRepetition(inputPassword) {
    for (var i = 0; i < inputPassword.length; i++){
      if (inputPassword[i] === inputPassword[i + 1] && inputPassword[i + 1] === inputPassword[i + 2]){
        tripleCount = tripleCount + 1;
      }
    }
  }
  function checkConsecutiveCharacters(inputPassword)
  {

  }
  checkTwoCharRepetition(registerFormPassword.value)
  checkThreeCharRepetition(registerFormPassword.value)
  checkConsecutiveCharacters(passwordArray)
  for (let i=0; i<passwordArray.length; i++){


    if (validation.isNumber(passwordArray[i])){
      rating.number = 2;
    } else if (validation.isLowercase(passwordArray[i])){
      rating.lowercase = 2;
    } else if (validation.isUppercase(passwordArray[i])){
      rating.uppercase = 2;
    } else if (validation.isSpecialChar(passwordArray[i])){
      rating.specialChar = 2;
    } else if(!validation.checkConsecutiveCharacters(passwordArray)) {
      rating.consecutive = 2;
    }
  }

  function assessTotalScore(){
    var ratingElement = document.querySelector(".rating");
    const barContainer = document.getElementById('bar-container');
    rating.total = rating.number + rating.lowercase + rating.uppercase + rating.specialChar + rating.consecutive;
    if(tripleCount === 0 && duplicateCount === 0 && registerFormPassword.value.length > 8)
      rating.total = rating.total + 2
    if(duplicateCount > 0 && tripleCount === 0 && registerFormPassword.value.length > 8)
      rating.total = rating.total + 1

    if (rating.total < 4){
      ratingElement.innerHTML = "Weak";
      ratingElement.classList.remove("moderatePassword", "strongPassword");
      ratingElement.classList.add("weakPassword");
      barContainer.classList.remove("moderatePassword", "strongPassword");
      barContainer.classList.add("weakPassword");
    } else if (rating.total < 8){
      ratingElement.innerHTML = "Medium";
      ratingElement.classList.remove("weakPassword", "strongPassword");
      ratingElement.classList.add("moderatePassword");
      barContainer.classList.remove("weakPassword", "strongPassword");
      barContainer.classList.add("moderatePassword");
    } else if (rating.total >= 8){
      ratingElement.innerHTML = "Strong";
      ratingElement.classList.remove("weakPassword", "moderatePassword");
      ratingElement.classList.add("strongPassword");
      barContainer.classList.remove("weakPassword", "moderatePassword");
      barContainer.classList.add("strongPassword");
    }
  }

  assessTotalScore();
});
